import Collection from '../valueObject/Collection';
import TypeString from '../valueObject/TypeString';

export default class CSRFTokenFactory {
    reconstitute(data: Collection): TypeString {
        return new TypeString(data.get('csrf_token'));
    }
}
